// extracted by mini-css-extract-plugin
module.exports = {"main":"main-list-main-list-main-048b4f62"};